import { useMemo } from 'react';
import { usePatientVirtualAppointments } from '../../../../hooks/useVirtualAppointments';
import type { VirtualAppointmentDto } from '../../../../services/virtualAppointments';

const NONE: VirtualAppointmentDto[] = [];

interface HistoryParams {
    patientId: string;
    /** This document's group, when it already has one (a resumed draft or a re-edit). */
    keepGroupId: string | null;
    enabled: boolean;
}

// Every VA outside this document, newest first: earlier documents' and the manually added ones.
export function useVirtualAppointmentHistory({
    patientId,
    keepGroupId,
    enabled
}: HistoryParams): VirtualAppointmentDto[] | undefined {
    const { data } = usePatientVirtualAppointments(patientId, {}, { enabled, fresh: true });
    return useMemo(() => {
        if (!enabled) return undefined;
        if (!data) return NONE;
        return data
            .filter((va) => va.sourceEventGroupId === null || va.sourceEventGroupId !== keepGroupId)
            .sort((a, b) => b.createdAt.localeCompare(a.createdAt));
    }, [data, enabled, keepGroupId]);
}
